export interface WatchEnvironment {
  api: string;
  production: boolean;
  /** Grafana Faro collector for browser errors; empty disables reporting */
  faroUrl?: string;
}

const environment: WatchEnvironment = {
  api: "https://sandbox.eudi-wallet.org/api",
  production: false,
};

export function getEnv(): WatchEnvironment {
  return (window as Window & { env?: WatchEnvironment }).env || environment;
}
